// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClusterOutlinedSvg from "@ant-design/icons-svg/es/asn/ClusterOutlined";
import AntdIcon from '../components/AntdIcon';

var ClusterOutlined = function ClusterOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClusterOutlinedSvg
  }));
};

ClusterOutlined.displayName = 'ClusterOutlined';
export default React.forwardRef(ClusterOutlined);